import React, { memo, useCallback } from 'react';
import classNames from 'classnames';
import { TextLink } from '@johnlewispartnership/wtr-ingredients/ingredients/TextLink';
import { Link } from 'react-router-dom';

import { yieldToMain } from 'utils/yield-to-main';
import { pushMenuClick } from 'utils/gtm';
import urls from 'constants/urls';

import SeasonalMenu from '../SeasonalMenu';

import styles from './LinksBar.scss';

const ConnectedLinksBar = memo(() => {
  const menuClickHandler = useCallback(event => {
    yieldToMain().then(() => {
      pushMenuClick(event.target.textContent);
    });
  }, []);

  return (
    <div className={styles.siteHeaderLinks}>
      <nav className={classNames(styles.primaryLinks)} aria-label="Main navigation">
        <SeasonalMenu />
        <TextLink
          href={urls.offers}
          className={styles.offers}
          id="site-header-offers"
          data-testid="site-header-offers"
          onClick={menuClickHandler}
          underline="none"
        >
          Offers
        </TextLink>
        <TextLink
          href={urls.entertainingHome}
          className={styles.links}
          data-testid="site-header-entertaining"
          id="site-header-entertaining"
          onClick={menuClickHandler}
          underline="none"
        >
          Entertaining
        </TextLink>
        <TextLink
          href={urls.new}
          id="site-header-new"
          data-testid="site-header-new"
          className={styles.links}
          onClick={menuClickHandler}
          underline="none"
        >
          New
        </TextLink>
        <TextLink
          component={Link}
          id="site-header-recipes"
          data-testid="site-header-recipes"
          className={styles.links}
          to="/ecom/recipes"
          onClick={menuClickHandler}
          underline="none"
        >
          Recipes
        </TextLink>
        <TextLink
          id="site-header-inspiration"
          data-testid="site-header-inspiration"
          className={styles.links}
          href={urls.inspiration}
          onClick={menuClickHandler}
          underline="none"
        >
          Inspiration
        </TextLink>
      </nav>
    </div>
  );
});

ConnectedLinksBar.displayName = 'Links';

export default ConnectedLinksBar;
